module.exports = __webpack_public_path__ + "static/media/moose.27e28ead.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/uncomp/moose.png
// module id = 57
// module chunks = 0